import StandardNoticeServer from './StandardNoticeServer';

export default function useNoticeServer() {
  return StandardNoticeServer.getInstance();
}
